import dayjs from "dayjs";
import { useMemo } from "react";
import type { ClinicalInsightDateRange, ClinicalPractitionerEntry } from "src-next/modules/clinical-insights/types/analysisTypes";

export function useInsightEmptyLabels(
  dateRange: ClinicalInsightDateRange | undefined,
  practitionerFilter: string,
  practitioner: ClinicalPractitionerEntry[] | undefined,
  periodDisplayLabel?: string
) {
  const emptyPeriodLabel =
    periodDisplayLabel ??
    (dateRange?.startDate
      ? dayjs(dateRange.startDate).format("MMMM [de] YYYY")
      : "este período");

  const emptyPractitionerLabel = useMemo(() => {
    if (practitionerFilter === "all") return "todos os profissionais";
    const entry = practitioner?.find((p) => p.resource?.id === practitionerFilter);
    const name = entry?.resource?.name?.[0]?.text;
    if (name) return name;
    return "este profissional";
  }, [practitioner, practitionerFilter]);

  return { emptyPeriodLabel, emptyPractitionerLabel };
}
